import { render, staticRenderFns } from "./GateReportEventCard.vue?vue&type=template&id=6b34c550"
import script from "./GateReportEventCard.vue?vue&type=script&lang=ts"
export * from "./GateReportEventCard.vue?vue&type=script&lang=ts"
import style0 from "./GateReportEventCard.vue?vue&type=style&index=0&id=6b34c550&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports